import { Directive, DoCheck, Host, Optional } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';

/**
 * Attaches globally to every <ag-grid-angular> element. On each change-detection
 * cycle it checks whether the grid's columnDefs reference has been seen before;
 * if not, it walks the defs (including nested `children`) and seeds
 * `headerTooltip` from `headerName` when one isn't already set.
 *
 * Result: every column header that gets truncated will show a native browser
 * tooltip with its full name on hover. Zero changes required in the ~100
 * per-grid ColDef arrays across the codebase.
 */
@Directive({ selector: 'ag-grid-angular' })
export class AgGridHeaderTooltipDirective implements DoCheck {
  private seen = new WeakSet<object>();

  constructor(@Optional() @Host() private grid: AgGridAngular) {}

  ngDoCheck(): void {
    if (!this.grid) return;
    const cols: any = (this.grid as any).columnDefs;
    if (!cols || typeof cols !== 'object') return;
    if (this.seen.has(cols)) return;
    this.seen.add(cols);
    if (Array.isArray(cols)) {
      this.seedTooltips(cols);
    }
  }

  private seedTooltips(cols: any[]): void {
    for (const col of cols) {
      if (!col || typeof col !== 'object') continue;
      if (typeof col.headerName === 'string' && col.headerName && !col.headerTooltip) {
        col.headerTooltip = col.headerName;
      }
      if (Array.isArray(col.children)) {
        this.seedTooltips(col.children);
      }
    }
  }
}
